import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

import { ButtonContainer, ButtonPrimary } from '@warrenbrasil/nebraska-web';

import {
  RLPPageData,
  RLPStatus,
  updateRLPStatus,
  UpdateRLPStatusValues
} from '@/modules/trade/services/rlp';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';

interface Props {
  pageData: RLPPageData;
}
interface Emits {
  (e: 'refresh'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Activation',
  props: {
    pageData: null
  },
  emits: ["refresh"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'refresh'): void;
}), expose: any, slots: any, attrs: any }) {





const isLoading = ref(false);

const handleRLPActivation = async () => {
  try {
    isLoading.value = true;

    const data = await updateRLPStatus(UpdateRLPStatusValues.enable);

    notify({
      group: 'wrn-notifications',
      text: data.message,
      type:
        data.status === RLPStatus.Active
          ? NotificationTypes.success
          : NotificationTypes.info,
      duration: 6000
    });
    emit('refresh');
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Não foi possível ativar o Warren RLP. Aguarde um momento e tente novamente.',
      type: NotificationTypes.error
    });
  } finally {
    isLoading.value = false;
  }
};

return { __sfc: true,emit, isLoading, handleRLPActivation, ButtonContainer, ButtonPrimary }
}

})